/* eslint-disable no-undef */
export const HoursFooter = {
    props: ['results','selectHoursCustom'],
    data() {
      return {
        selectHours: (this.selectHoursCustom ? this.selectHoursCustom : 'sales'),
      }
    },
    methods: {
      clicHours:function(data){
        this.selectHours = data
    },
    },
  }